module.exports = __webpack_public_path__ + "img/icon-status-06.9dde6964.svg";